module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLight.d88fa2ca.ttf";